export const PlacementData = [
  {
    id: 1,
    Year: "2016 - 17",
    Offers: "92",
    AveragePackage: "3.4",
    HighestPackage: "15.5",
  },
  {
    id: 2,
    Year: "2017 - 18",
    Offers: "90",
    AveragePackage: "3.3",
    HighestPackage: "10.12",
  },
  {
    id: 3,
    Year: "2018 - 19",
    Offers: "135",
    AveragePackage: "4.21",
    HighestPackage: "8",
  },
  {
    id: 4,
    Year: "2019 - 20",
    Offers: "347",
    AveragePackage: "4.51",
    HighestPackage: "8",
  },
  {
    id: 5,
    Year: "2020 - 21",
    Offers: "411",
    AveragePackage: "5.1",
    HighestPackage: "37",
  },
  {
    id: 6,
    Year: "2021 - 22",
    Offers: "1023",
    AveragePackage: "6.2",
    HighestPackage: "50",
  },
  {
    id: 7,
    Year: "2022 - 23",
    Offers: "991",
    AveragePackage: "7",
    HighestPackage: "52",
  },
  {
    id: 8,
    Year: "2023 - 24",
    Offers: "800",
    AveragePackage: "6",
    HighestPackage: "42",
  }
];
